export default {
      id: "tip-jar-usage",
      viewBox: "0 0 272.88 389.19",
      url: __webpack_public_path__ + "img/icons.b8e1d04b.svg#tip-jar",
      toString: function () {
        return this.url;
      }
    }